import type React from 'react';

import { DeleteVariantIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

import st from './ConfirmDeletionDialog.module.sass';

export interface ConfirmDeletionDialogProps {
  title: string;
  subtitle: string;
  cancelLabel: string;
  confirmLabel: string;
  onConfirm: VoidFunction;
  onReject: VoidFunction;
  /** Иконка диалога (по умолчанию DeleteVariantIcon). */
  icon?: React.ReactNode;
}

function ConfirmDeletionDialog({
  title,
  subtitle,
  cancelLabel,
  confirmLabel,
  onConfirm,
  onReject,
  icon = <DeleteVariantIcon className={st.Icon} />,
}: ConfirmDeletionDialogProps): React.JSX.Element {
  return (
    <div className={st.ConfirmDeletionDialog}>
      <div className={st.Header}>
        <span className={st.Icon}>{icon}</span>
        <div className={st.Description}>
          <span className={st.Title}>{title}</span>
          <span className={st.Subtitle}>{subtitle}</span>
        </div>
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {cancelLabel}
        </Control.Button>
        <Control.Button
          className={st.Action}
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {confirmLabel}
        </Control.Button>
      </div>
    </div>
  );
}

export { ConfirmDeletionDialog };
